import { useState } from 'react';
import { Lock } from 'lucide-react';
import { PRESENTATION } from '../presentationConfig';

export const UNLOCK_KEY = 'jsp_unlocked';
export const VIEWER_UNLOCK_KEY = 'jsp_viewer_unlocked';

const match = (value, passcode) => value.trim().toLowerCase() === passcode.toLowerCase();

// Control-centre unlock (preview / present / presenter). Accepts ?key= for the team's own links.
export function isUnlocked() {
  if (typeof window === 'undefined') return false;
  const key = new URLSearchParams(window.location.search).get('key');
  if (key && match(key, PRESENTATION.passcode)) {
    localStorage.setItem(UNLOCK_KEY, '1');
    return true;
  }
  return localStorage.getItem(UNLOCK_KEY) === '1';
}

// Viewer unlock (/watch). Separate passcode + storage key so an approver never unlocks the control centre.
export function isViewerUnlocked() {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem(VIEWER_UNLOCK_KEY) === '1';
}

export function PasscodeGate({ onUnlock, passcode = PRESENTATION.passcode, storageKey = UNLOCK_KEY, storage = 'local', subtitle = 'Private preview · enter the passcode you were sent', cta = 'Open presentation' }) {
  const [value, setValue] = useState('');
  const [error, setError] = useState(false);
  const submit = (e) => {
    e.preventDefault();
    if (match(value, passcode)) {
      (storage === 'session' ? sessionStorage : localStorage).setItem(storageKey, '1');
      onUnlock();
    } else {
      setError(true);
    }
  };
  return (
    <div className="pk-gate" data-testid="pk-passcode-gate">
      <div className="pk-ready-glow" />
      <form className="pk-glass pk-gate-card" onSubmit={submit}>
        <img src="/nichecom-logo-nav.png" alt="NicheCom" style={{ height: 40 }} />
        <div className="pk-gate-title">{PRESENTATION.title}</div>
        <div className="pk-gate-sub">{subtitle}</div>
        <label className="pk-gate-field">
          <Lock size={16} />
          <input
            type="password"
            autoFocus
            value={value}
            onChange={(e) => { setValue(e.target.value); setError(false); }}
            placeholder="Passcode"
            data-testid="pk-passcode-input"
          />
        </label>
        {error && <div className="pk-gate-error" data-testid="pk-passcode-error">That passcode isn't right.</div>}
        <button type="submit" className="pk-btn pk-btn-lime" data-testid="pk-passcode-submit">{cta}</button>
      </form>
    </div>
  );
}
